import React, { Component } from 'react';
import { SofaFormControl, SofaInput, getPropsForSofaInput } from '@sofology/sofologycomponents';

import './SofaYearsMonthsInputsWrapper.scss';

import { messageArrayToHelperText } from 'helpers';
import { PropertyValueType, nullableValueToString } from 'helpers/dynamicFormHelpers';

interface OwnProps {
    label: string;
    monthsContorl: SofaFormControl<PropertyValueType>;
    yearsControl: SofaFormControl<PropertyValueType>;
}

export class SofaYearsMonthsInputsWrapper extends Component<OwnProps> {
    private element = React.createRef<HTMLDivElement>();

    render(): JSX.Element {
        const { monthsContorl, yearsControl, label } = this.props;

        const dayInputHelperText = messageArrayToHelperText([monthsContorl.errorMessage, yearsControl.errorMessage]);
        const errorClass = Boolean(monthsContorl.errorMessage || yearsControl.errorMessage);

        return (
            <div className={'sofa-years--months-inputs-wrapper'} ref={this.element}>
                <div className='sofa-years--months-inputs-wrapper__title'>
                    {label} *
                </div>
                <div className='sofa-years--months-inputs-wrapper__content'>
                    <SofaInput
                        label='YY'
                        inputProps={{ min: 0, style: { textAlign: 'center' }, inputMode: 'decimal', pattern: '[0-9]*', autoCorrect: 'off', autoComplete: 'years', maxLength: '2' }}
                        {...getPropsForSofaInput(yearsControl)}
                        addErrorClass={errorClass}
                        helperText={dayInputHelperText}
                        value={nullableValueToString(yearsControl.value)}
                    />
                    <SofaInput
                        label='MM'
                        inputProps={{ min: 0, style: { textAlign: 'center' }, inputMode: 'decimal', pattern: '[0-9]*', autoCorrect: 'off', autoComplete: 'months', maxLength: '2' }}
                        {...getPropsForSofaInput(monthsContorl)}
                        addErrorClass={errorClass}
                        helperText={null}
                        value={nullableValueToString(monthsContorl.value)}
                    />
                </div>
            </div>
        );
    }
}